import { useMutation, useQuery } from '@apollo/client';
import { Grid } from '@material-ui/core';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  EDIT_CATEGORY,
  GET_ALL_CATEGORIES,
  GET_CATEGORY,
} from '../gql/categories';
import CategoryForm from './CategoryForm';
import Note from './layout/Note';
import PageContainer from './layout/PageContainer';
import PagePaper from './layout/PagePaper';
import Loading from './layout/Loading';

const FormWrapper = ({ id, category, error, editCategory }) => {
  const { folderName, displayName, disabled, desc } = category;

  const formik = useFormik({
    initialValues: {
      folderName,
      displayName,
      active: !disabled,
      desc,
    },
    validationSchema: Yup.object({
      folderName: Yup.string().trim().required('Please enter folder name'),
      displayName: Yup.string().trim().required('Please enter display name'),
    }),
    onSubmit: (input) => {
      input.disabled = !input.active;
      input.active = undefined;
      editCategory({ variables: { id, input } });
    },
  });
  return <CategoryForm formik={formik} error={error} edit={true} />;
};

const CategoryEdit = () => {
  const history = useHistory();
  const { id } = useParams();
  const { loading, error, data } = useQuery(GET_CATEGORY, {
    variables: { id },
  });
  const [editCategory, { error: editError }] = useMutation(EDIT_CATEGORY, {
    refetchQueries: [{ query: GET_ALL_CATEGORIES }],
    onCompleted() {
      history.push('/categories');
    },
  });

  if (loading) return <Loading></Loading>;
  if (error) {
    alert(JSON.stringify(error));
    return `Error! ${error}`;
  }

  return (
    <PageContainer title="Edit Category">
      <Note>Input info to edit category</Note>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PagePaper>
            <FormWrapper
              id={id}
              editCategory={editCategory}
              error={editError}
              category={data.category}
            />
          </PagePaper>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default CategoryEdit;
